/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Opportunitiesemptyvenues2Inputs */

const en_opportunitiesemptyvenues2 = /** @type {(inputs: Opportunitiesemptyvenues2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Live Room has been scanned in this window.`)
};

const de_opportunitiesemptyvenues2 = /** @type {(inputs: Opportunitiesemptyvenues2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In diesem Zeitraum wurde kein Live-Room gescannt.`)
};

/**
* | output |
* | --- |
* | "No Live Room has been scanned in this window." |
*
* @param {Opportunitiesemptyvenues2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const opportunitiesemptyvenues2 = /** @type {((inputs?: Opportunitiesemptyvenues2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Opportunitiesemptyvenues2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_opportunitiesemptyvenues2(inputs)
	return de_opportunitiesemptyvenues2(inputs)
});
export { opportunitiesemptyvenues2 as "opportunitiesEmptyVenues" }